export const AdvanceSettingsConfig = (t, pressure, flow) => ({
  cipAndShutdownIdentification: {
    // window: {
    //   key: "window",
    //   minValue: 3,
    //   maxValue: 20,
    //   label: t("advanceSettings.window"),
    // },
    qp_pct_change_threshold: {
      key: "qp_pct_change_threshold",
      minValue: 1,
      maxValue: 50,
      label: t("advanceSettings.qp_pct_change_threshold"),
    },
    tmp_pct_change_threshold: {
      key: "tmp_pct_change_threshold",
      minValue: 1,
      maxValue: 50,
      label: t("advanceSettings.tmp_pct_change_threshold"),
    },
    short_time_threshold: {
      key: "short_time_threshold",
      minValue: 60,
      maxValue: 1200,
      label: t("advanceSettings.short_time_threshold"),
    },

    time1: {
      key: "time1",
      minValue: 3,
      maxValue: 44,
      label: t("advanceSettings.time1"),
    },
    time2: {
      key: "time2",
      minValue: 45,
      maxValue: 300,
      label: t("advanceSettings.time2"),
    },
    minimum_duration_between_cips: {
      key: "minimum_duration_between_cips",
      minValue: 2,
      maxValue: 30,
      label: t("advanceSettings.minimum_duration_between_cips"),
    },
    norm_tmp_threshold: {
      key: "norm_tmp_threshold",
      minValue: pressure === "bar" ? 0.05 : pressure === "psig" ? 0.7 : 0.05,
      maxValue: pressure === "bar" ? 1 : pressure === "psig" ? 14.5 : 1,
      label: t("advanceSettings.norm_tmp_threshold").replace(
        "<unit>",
        pressure
      ),
    },
    filtrate_flow_threshold: {
      key: "filtrate_flow_threshold",
      minValue:
        flow === "m³/h"
          ? -0.01
          : flow === "m³/d"
          ? -0.24
          : flow === "gpm"
          ? -0.04
          : -0.01,
      maxValue:
        flow === "m³/h"
          ? 0.01
          : flow === "m³/d"
          ? 0.24
          : flow === "gpm"
          ? 0.04
          : 0.01,
      label: t("advanceSettings.filtrate_flow_threshold").replace(
        "<unit>",
        flow
      ),
    },

    minimum_backwash_between_cips: {
      key: "minimum_backwash_between_cips",
      minValue: 1,
      maxValue: 100,
      label: t("advanceSettings.minimum_backwash_between_cips"),
    },
    minimum_backwash_between_cebs: {
      key: "minimum_backwash_between_cebs",
      minValue: 0,
      maxValue: 100,
      label: t("advanceSettings.minimum_backwash_between_cebs"),
    },
    start_tmp_pct_change_threshold: {
      key: "start_tmp_pct_change_threshold",
      minValue: -20,
      maxValue: 0,
      label: t("advanceSettings.start_tmp_pct_change_threshold"),
    },
    min_shutdown_days: {
      key: "min_shutdown_days",
      minValue: 0.04,
      maxValue: 5,
      label: t("advanceSettings.min_shutdown_days"),
    },
    default_approach: {
      key: "default_approach",
      dropdown: true,
      options: [
        t("advanceSettings.permeateFlow"),
        t("advanceSettings.normalizeTMP"),
      ],
      label: t("advanceSettings.default_approach"),
    },
  },

  cipPredictionAndRecommendation: {
    norm_tmp_threshold_cip: {
      key: "norm_tmp_threshold_cip",
      minValue: pressure === "bar" ? 0.2 : pressure === "psig" ? 2.9 : 0.2,
      maxValue: pressure === "bar" ? 2 : pressure === "psig" ? 29 : 2,
      label: t("advanceSettings.norm_tmp_threshold_cip").replace(
        "<unit>",
        pressure
      ),
    },

    min_bwd_multiplier: {
      key: "min_bwd_multiplier",
      minValue: 0.1,
      maxValue: 1,
      label: t("advanceSettings.min_bwd_multiplier"),
    },
    max_bwd_multiplier: {
      key: "max_bwd_multiplier",
      minValue: 0.1,
      maxValue: 2,
      label: t("advanceSettings.max_bwd_multiplier"),
    },
    optimize_mode: {
      key: "optimize_mode",
      isBoolean: true,
      options: {
        option1: {
          name: t("ValueStrings.yes"),
          value: "true",
          key: "optimize_mode_yes",
        },
        option2: {
          name: t("ValueStrings.no"),
          value: "false",
          key: "optimize_mode_no",
        },
      },
      label: t("advanceSettings.optimize_mode"),
    },
    optimization_target: {
      key: "optimization_target",
      dropdown: true,
      options: [
        t("advanceSettings.minimizeTotalCost"),
        t("advanceSettings.maximixeProductionVolume"),
        t("advanceSettings.minimizeEnergyCost"),
      ],
      label: t("advanceSettings.optimization_target"),
    },
  },
});
